@for (n of columnArray; track n) {
  <div [ngClass]="{'col': columns > 1, 'select-list': columns <= 1}">
    @for (competency of getCompetencies(n); track competency) {
      <div (click)="competencyClicked(competency)" class="select-list-item"
        [ngClass]="{'clickable': iconClasses}">
        @if (iconClasses && iconSide === 'left') {
          <span class="item-icon">
            <i [ngClass]="iconClasses"></i>&nbsp;
          </span>
        }
        <i class="fa fa-cube"></i> {{competency.name}}
        @if (iconClasses && iconSide === 'right') {
          <span class="item-icon pull-right">
            <i [ngClass]="iconClasses"></i>&nbsp;
          </span>
        }
      </div>
    }
  </div>
}

